"use client"

import styled from "@emotion/styled"
import { useInView } from "react-intersection-observer"
import { transitionDelayTime, TransitionUp, useInViewConfig } from "ui"
import { ProjectPage } from "utils/projects"
import ProjectBenefitsSlider from "./ProjectBenefitsSlider"
import WhiteBgHeading from "./WhiteBgHeading"

type Props = {
  data: ProjectPage["rentProjectBenefits"]
  locale: string
}

const StyledBenefits = styled.section`
  --benefits-black: #011727;
  display: flex;
  justify-content: center;
  padding-block: 60px;
  width: 100%;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding-block: 80px;
  }
`
const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  padding-inline: 20px;
  max-width: 1240px;
  width: 100%;
  overflow: hidden;

  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 40px;
  }
`

const ProjectBenefits = ({ data, locale }: Props) => {
  const { ref, inView } = useInView(useInViewConfig)

  const anchorId = data?.anchorId
  const title = data?.title
  const subTitle = data?.subTitle
  const items = data?.items

  return (
    <TransitionUp ref={ref} $inView={inView} $delay={transitionDelayTime}>
      <StyledBenefits {...(anchorId ? { id: anchorId } : {})}>
        <StyledContainer>
          <WhiteBgHeading title={title} subTitle={subTitle} />
          {items?.length && <ProjectBenefitsSlider items={items} locale={locale} />}
        </StyledContainer>
      </StyledBenefits>
    </TransitionUp>
  )
}
export default ProjectBenefits
